import clsx from 'clsx';
import { Activity, AlertTriangle, CheckCircle, XCircle } from 'lucide-react';
import { memo } from 'react';

import type { HealthStatus } from '../../../shared/api/types';
import styles from './system-health-indicator.module.scss';

type SystemHealthIndicatorProps = {
  status: HealthStatus;
};

const SystemHealthIndicator = memo(({ status }: SystemHealthIndicatorProps) => {
  const getStatusConfig = () => {
    switch (status) {
      case 'healthy':
        return {
          icon: CheckCircle,
          label: 'System Healthy',
          description: 'All systems operating normally',
          className: styles.healthy,
        };
      case 'warning':
        return {
          icon: AlertTriangle,
          label: 'System Warning',
          description: 'Some metrics require attention',
          className: styles.warning,
        };
      case 'critical':
        return {
          icon: XCircle,
          label: 'System Critical',
          description: 'Immediate attention required',
          className: styles.critical,
        };
      default:
        return {
          icon: Activity,
          label: 'Unknown Status',
          description: 'Unable to determine system status',
          className: styles.unknown,
        };
    }
  };

  const config = getStatusConfig();

  return (
    <div className={clsx(styles.healthIndicator, config.className)}>
      <div className={styles.healthIcon}>
        <config.icon size={24} />
      </div>

      <div className={styles.healthContent}>
        <div className={styles.healthLabel}>{config.label}</div>
        <div className={styles.healthDescription}>{config.description}</div>
      </div>
    </div>
  );
});

SystemHealthIndicator.displayName = 'SystemHealthIndicator';

export { SystemHealthIndicator };
